import React, { useEffect, useState } from "react";
import LeaveProcessService from "../services/LeaveProcessService";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from "../Utils/LoadingContext";
import * as XLSX from "xlsx";


const LeaveBalanceView = () => {

    const { setLoading } = useLoading();
    const empcode = localStorage.getItem("empcode");
    const currentYear = new Date().getFullYear();

    const [filters, setFilters] = useState({

        EmployeeCode: "",
        Plant: 0,
        YearNo: currentYear

    });

    const [plants, setPlants] = useState([]);
    const [leaveList, setLeaveList] = useState([]);
    const [leaveTypeList, setLeaveTypeList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [newLeave, setNewLeave] = useState({

        EmployeeCode: "",
        YearNo: currentYear,
        LeaveTypeID: "",
        OpeningBalance: 0

    });



    const yearList = [];


    for (
        let year = currentYear - 1;
        year <= currentYear + 5;
        year++
    ) {
        yearList.push(year);
    }


    useEffect(() => {

        loadDropdowns();

        fetchLeaveList();

    }, []);

    const loadDropdowns = async () => {


        try {


            const plantRes =
                await EmployeeProcessService.getPlant(empcode);



            if (
                plantRes?.data?.statusCode === 200
            ) {

                setPlants(
                    plantRes.data.result
                );

            }


        }
        catch (error) {
            console.log(error);
        }

    };







    const fetchLeaveList = async () => {


        try {


            const formData = new FormData();


            formData.append(
                "Type",
                "GetLeaveList"
            );


            formData.append(
                "LeaveType",
                "GetLeaveType"
            );



            const response =
                await LeaveProcessService.getEmployeeList(formData);



            if (
                response?.data?.statusCode === 200
            ) {

                setLeaveTypeList(
                    response.data.result || []
                );

            }


        }
        catch (error) {

            console.log(error);

            setLeaveTypeList([]);

        }


    };








    const handleChange = (e) => {


        const { name, value } = e.target;


        setFilters(prev => ({

            ...prev,

            [name]: value

        }));

    };








    const getLeaveBalance = async () => {

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append(
                "EmployeeCode",
                filters.EmployeeCode
            );
            formData.append(
                "Plant",
                filters.Plant || 0
            );
            formData.append(
                "YearNo",
                filters.YearNo
            );
            const res = await LeaveProcessService.getEmployeeLeaveBalance(formData);

            if (res?.data?.statusCode === 200) {
                setLeaveList(
                    res.data.result || []
                );

            }
            else {

                setLeaveList([]);
                alert("No Data Found");

            }


        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }

    };

    const changeOpeningBalance = (index, value) => {


        let temp = [...leaveList];

        temp[index].openingBalance = value;

        setLeaveList(temp);

    };

    const updateLeaveBalance = async (row) => {
        const payload = {

            EmployeeCode:
                row.employeeCode,


            LeaveTypeID:
                row.leaveTypeID,


            YearNo:
                row.yearNo,


            OpeningBalance:
                Number(row.openingBalance)


        };


        setLoading(true);


        try {


            const res =
                await LeaveProcessService
                    .setEmployeeLeaveBalance(payload);



            if (
                res?.data?.statusCode === 200
            ) {

                alert(
                    "Updated Successfully"
                );


                setEditIndex(null);

                getLeaveBalance();

            }


        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }


    };









    const saveNewLeave = async () => {

        if (!newLeave.EmployeeCode) {
            alert("Employee Code Required");
            return;
        }
        if (!newLeave.LeaveTypeID) {
            alert("Select Leave Type");
            return;
        }
        if (!newLeave.YearNo) {
            alert("Select year");
            return;
        }
        // const payload = {

        //     EmployeeCode:newLeave.EmployeeCode,
        //     LeaveTypeID:newLeave.LeaveTypeID,
        //     YearNo:newLeave.YearNo,
        //     OpeningBalance:Number(newLeave.OpeningBalance)
        // };

        const payload = new FormData();

        payload.append("EmployeeCode", newLeave.EmployeeCode);
        payload.append("LeaveTypeID", newLeave.LeaveTypeID);
        payload.append("YearNo", newLeave.YearNo);
        payload.append("OpeningBalance", newLeave.OpeningBalance);

        setLoading(true);

        try {
            const res = await LeaveProcessService.setEmployeeLeaveBalance(payload);

            if (res?.data?.statusCode === 200) {
                alert("Saved Successfully");
                setShowModal(false);

                getLeaveBalance();


            }


        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }


    };








    const downloadExcel = () => {


        const ws =
            XLSX.utils.json_to_sheet(leaveList);


        const wb =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "Leave Balance"
        );


        XLSX.writeFile(
            wb,
            "EmployeeLeaveBalance.xlsx"
        );


    };








    return (

        <div className="container mt-3">


            <h4 className="text-primary mb-3">
                Employee Leave Balance
            </h4>




            <div className="row mb-3">


                <div className="col-md-3">

                    <label className="text-primary">
                        Employee Code
                    </label>

                    <input

                        className="form-control"

                        name="EmployeeCode"

                        value={filters.EmployeeCode}

                        onChange={handleChange}

                    />

                </div>





                <div className="col-md-3">

                    <label className="text-primary">
                        Plant
                    </label>


                    <select

                        className="form-select"

                        name="Plant"

                        value={filters.Plant}

                        onChange={handleChange}

                    >


                        <option value="0">
                            All Plant
                        </option>


                        {
                            plants.map(p =>

                                <option
                                    key={p.id}
                                    value={p.id}
                                >
                                    {p.name}
                                </option>

                            )

                        }


                    </select>

                </div>






                <div className="col-md-3">

                    <label className="text-primary">
                        Year
                    </label>


                    <select

                        className="form-select"

                        name="YearNo"

                        value={filters.YearNo}

                        onChange={handleChange}

                    >

                        {
                            yearList.map(y =>

                                <option
                                    key={y}
                                    value={y}
                                >
                                    {y}
                                </option>

                            )

                        }

                    </select>


                </div>





                <div className="col-md-3 mt-4">


                    <button

                        className="btn btn-primary me-2"

                        onClick={getLeaveBalance}

                    >
                        Search
                    </button>



                    <button

                        className="btn btn-info"

                        onClick={() => setShowModal(true)}

                    >
                        New
                    </button>



                </div>



            </div>







            {
                leaveList.length > 0 &&


                <div>


                    <button

                        className="btn btn-success btn-sm mb-2"

                        onClick={downloadExcel}

                    >
                        Export
                    </button>



                    <table className="table table-bordered">


                        <thead className="table-dark">

                            <tr>

                                <th>Employee Code</th>
                                <th>Name</th>
                                <th>Plant</th>
                                <th>Department</th>
                                <th>Leave</th>
                                <th>Year</th>
                                <th>Opening</th>
                                <th>Available</th>
                                <th>Action</th>

                            </tr>

                        </thead>



                        <tbody>


                            {
                                leaveList.map((x, index) => (


                                    <tr key={index}>


                                        <td>{x.employeeCode}</td>

                                        <td>{x.employeeName}</td>

                                        <td>{x.plant}</td>

                                        <td>{x.department}</td>

                                        <td>{x.leaveName}</td>

                                        <td>{x.yearNo}</td>


                                        <td>

                                            {
                                                editIndex === index ?

                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={x.openingBalance}
                                                        step="0.01"

                                                        min="0"
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            // Allow only number with max 2 decimal
                                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                changeOpeningBalance(
                                                                    index,
                                                                    value
                                                                );
                                                            }

                                                        }}

                                                    />

                                                    :

                                                    x.openingBalance

                                            }

                                        </td>



                                        <td>
                                            {x.availableBalance}
                                        </td>



                                        <td>


                                            {
                                                editIndex === index ?

                                                    <button

                                                        className="btn btn-success btn-sm"

                                                        onClick={() => updateLeaveBalance(x)}

                                                    >
                                                        Update
                                                    </button>

                                                    :

                                                    <button

                                                        className="btn btn-warning btn-sm"

                                                        onClick={() => setEditIndex(index)}

                                                    >
                                                        Edit
                                                    </button>

                                            }


                                        </td>


                                    </tr>


                                ))

                            }


                        </tbody>


                    </table>


                </div>


            }






            {
                showModal &&


                <div className="modal show d-block"

                    style={{
                        background: "rgba(0,0,0,.5)"
                    }}>


                    <div className="modal-dialog">


                        <div className="modal-content">


                            <div className="modal-header">

                                <h5>
                                    New Leave Balance
                                </h5>

                                <button

                                    className="btn-close"

                                    onClick={() => setShowModal(false)}

                                ></button>


                            </div>



                            <div className="modal-body">


                                <label>
                                    Employee Code
                                </label>

                                <input
                                    type="number"
                                    className="form-control mb-2"

                                    value={newLeave.EmployeeCode}

                                    onChange={(e) =>

                                        setNewLeave({

                                            ...newLeave,

                                            EmployeeCode: e.target.value

                                        })

                                    }

                                />





                                <label>
                                    Year
                                </label>


                                <select

                                    className="form-select mb-2"

                                    value={newLeave.YearNo}

                                    onChange={(e) =>

                                        setNewLeave({

                                            ...newLeave,

                                            YearNo: e.target.value

                                        })

                                    }

                                >

                                    {
                                        yearList.map(y =>

                                            <option value={y} key={y}>
                                                {y}
                                            </option>

                                        )

                                    }

                                </select>





                                <label>
                                    Leave Type
                                </label>


                                <select

                                    className="form-select mb-2"

                                    value={newLeave.LeaveTypeID}

                                    onChange={(e) =>

                                        setNewLeave({

                                            ...newLeave,

                                            LeaveTypeID: e.target.value

                                        })

                                    }

                                >


                                    <option value="">
                                        Select Leave
                                    </option>


                                    {
                                        leaveTypeList.map((x, i) => (


                                            <option

                                                key={i}

                                                value={x.leaveTypeID}

                                            >
                                                {x.leaveCode}
                                            </option>


                                        ))

                                    }


                                </select>






                                <label>
                                    Opening Balance
                                </label>


                                <input

                                    type="number"

                                    className="form-control"

                                    value={newLeave.OpeningBalance}

                                    onChange={(e) =>

                                        setNewLeave({

                                            ...newLeave,

                                            OpeningBalance: e.target.value

                                        })

                                    }

                                />



                            </div>



                            <div className="modal-footer">


                                <button

                                    className="btn btn-success"

                                    onClick={saveNewLeave}

                                >
                                    Save
                                </button>


                            </div>


                        </div>

                    </div>

                </div>

            }


        </div>


    );


};


export default LeaveBalanceView;